import {
    useCallback,
} from 'react'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    useGetRequestSpreadSheetAdapter,
} from 'app/shared-components/SkyNetSpreadSheet'
import StatusHandler from 'app/shared-components/StatusHandler'
import {
    AsyncMutationOptions,
} from 'app/types/request.types'
import {
    useSkyNetPagination, SkyNetPaginationContext,
} from 'app/shared-components/SkyNetPagination'
import requests from 'app/requests/RateCard.requests'
import useSimpleApiRequest from 'app/hooks/useSimpleApiRequest'
import {
    MarginsEditable, MarginsTable,
} from '../Margins.types'
import MarginsSpreadsheet from '../MarginsSpreadsheet'
import {
    prepareMarginsToBulkEdit,
} from '../Margins.utils'
import defaultRateCardsBulkSort from '../../RateCardsBulkEdit/RateCardsBulkEdit.utils'

export default function MarginsBulkEdit({
    onClose,
}: { onClose: () => void }) {
    const paginationOptions = useSkyNetPagination(100)
    const {
        isError, loaded, error, data, refetch,
    } = useGetRequestSpreadSheetAdapter<MarginsTable>({
        config: requests[RequestKeys.marginsFilterRequest],
        requestKey: RequestKeys.marginsFilterRequest,
        enabled: true,
        paginationOptions,
        defaultSort: defaultRateCardsBulkSort,
    })

    const {
        mutateAsync: bulkEdit,
    } = useSimpleApiRequest<{ items: MarginsEditable[] }>({
        name: 'MarginsBulkUpdate',
        title: 'Margins were updated',
        requestParams: requests.marginsBulkEdit(),
        onSuccess: refetch,
    })

    const onSave = useCallback(async (items: MarginsTable[], options?: AsyncMutationOptions) => {
        await bulkEdit({
            items: prepareMarginsToBulkEdit(items),
        }, {
            ...options,
            onSuccess: options?.onSuccess || onClose,
        })
    }, [
        bulkEdit,
        onClose,
    ])

    return (
        <StatusHandler
            isError={isError}
            isFetching={!loaded}
            error={error}
            isSuccess={loaded}
        >
            <SkyNetPaginationContext.Provider value={paginationOptions}>
                <MarginsSpreadsheet
                    data={data}
                    onCancel={onClose}
                    onSave={onSave}
                />
            </SkyNetPaginationContext.Provider>
        </StatusHandler>
    )
}
